export var SortBy;
(function (SortBy) {
    SortBy["Relevance"] = "relevance";
    SortBy["Fields"] = "fields";
})(SortBy || (SortBy = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "asc";
    SortDirection["Descending"] = "desc";
})(SortDirection || (SortDirection = {}));
export const buildRelevanceSortCriterion = () => ({
    by: SortBy.Relevance,
});
